var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29395 15.6947L9.03091 15.6785L19.37 5.37727C19.7757 4.9691 19.999 4.42704 19.999 3.85043C19.999 3.27382 19.7757 2.73176 19.37 2.32359L17.6676 0.611031C16.8561 -0.205297 15.4402 -0.200978 14.6352 0.607792L4.29395 10.9112V15.6947ZM16.1498 2.13787L17.8554 3.84719L16.1412 5.55543L14.4387 3.84395L16.1498 2.13787ZM6.44077 11.8118L12.9134 5.36215L14.6159 7.07471L8.14427 13.5222L6.44077 13.5276V11.8118Z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14682 19.9999H17.1746C18.3585 19.9999 19.3214 19.0313 19.3214 17.8403V8.48056L17.1746 10.6402V17.8403H5.53665C5.50874 17.8403 5.47976 17.8511 5.45185 17.8511C5.41643 17.8511 5.38101 17.8413 5.34451 17.8403H2.14682V2.72307H9.49646L11.6433 0.563477H2.14682C0.962849 0.563477 0 1.53206 0 2.72307V17.8403C0 19.0313 0.962849 19.9999 2.14682 19.9999Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit2);
export default __webpack_public_path__ + "static/media/iconEdit2.1237fa56c8fe90c96226a8fed85827c8.svg";
export { ForwardRef as ReactComponent };